import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import KidSignIn from "@/pages/KidSignIn";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import StudentDetail from "@/pages/StudentDetail";
import StudentHome from "@/pages/StudentHome";
import Homework from "@/pages/Homework";
import Learn from "@/pages/Learn";
import Progress from "@/pages/Progress";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen grid place-items-center text-[color:var(--tm-ink-3)]" data-testid="auth-loading">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

// Bounces the user to their student home when they're in kid mode.
function ParentOnly({ children }) {
  const { user } = useAuth();
  if (user && user.kid_locked_to) {
    return <Navigate to={`/students/${user.kid_locked_to}/home`} replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster richColors position="top-center" />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/kid" element={<KidSignIn />} />
            <Route path="/onboarding" element={<Protected><ParentOnly><Onboarding /></ParentOnly></Protected>} />
            <Route path="/dashboard" element={<Protected><ParentOnly><Dashboard /></ParentOnly></Protected>} />
            <Route path="/students/:id" element={<Protected><ParentOnly><StudentDetail /></ParentOnly></Protected>} />
            <Route path="/students/:id/home" element={<Protected><StudentHome /></Protected>} />
            <Route path="/students/:id/homework" element={<Protected><Homework /></Protected>} />
            <Route path="/students/:id/learn" element={<Protected><Learn /></Protected>} />
            <Route path="/students/:id/progress" element={<Protected><Progress /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
